import { render, staticRenderFns } from "./SharePageTemplate.vue?vue&type=template&id=5efae4de&scoped=true&"
import script from "./SharePageTemplate.vue?vue&type=script&lang=js&"
export * from "./SharePageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SharePageTemplate.vue?vue&type=style&index=0&id=5efae4de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efae4de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow,VSpacer})
